import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Edit3, Eye, Trash2, User } from 'react-feather';
import IconButton from '@mui/material/IconButton';
import '../../styles/table.css'; // Importing the external CSS
import Grid from '@mui/material/Grid2';
import { PlusCircle } from 'react-feather';
import { Chip, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Toastmessage from '../../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

const initialRows = [
  { id: '3', name: 'test' }
];


export default function Bonus({ apiResponse }) {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]); // Store filtered data
  const [searchText, setSearchText] = useState('');
  const [open, setOpen] = useState(false);
  const [deleteBonus, setBonus] = useState('')

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    // if (apiResponse?.data?.actions?.list) {
    fetchClients();
    // }
  }, [token, userID]); // Run effect when token or userID changes


  // Define fetchDesignation separately to reuse it
  const fetchClients = async () => {
    const input_token = 'ASSET_TYPE_LIST'; // Replace with your actual token
    const apiUrl = 'list_of_asset_types'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);


      if (data && data.success) {
        setRows(data.asset_type_list);
        setFilteredRows(data.asset_type_list); // Set filtered rows to the same data initially
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  const handleClickEdit = (id) => {
    navigate('/editasset', { state: { assetId: id } });
  };
  // const handleClickView = (id) => {
  //   navigate('/viewbonus', { state: { bonusId: id } });
  // };

  const columns = [
    {
      field: 'asset_type',
      headerName: 'Asset Name',
      flex: 5,
      renderCell: (params) => (
        <a className="location-link">
          {params.row.asset_type}
        </a>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status == 1 ? 'Active' : 'Inctive'}
          </div>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          {apiResponse?.data?.actions?.edit && (
            <IconButton
              onClick={() => handleClickEdit(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Edit3 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.delete && (
            <IconButton
              onClick={() => handleClickOpen(params.row.id)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
              }}
              size="small" // Decrease the button size
            >
              <Trash2 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
        </>
      ),
    },
  ];

  // const handleDelete = () => {
  //   const toast = Toastmessage('deleted successfully', true)
  //   setOpen(false);
  // };

  const handleDelete = async () => {

    const fetchData = async () => {
      const input_token = deleteBonus + 'DELETE_ASSET_TYPE';; // Replace with your actual token
      const apiUrl = 'delete_asset_type'; // Replace with the actual API endpoint
      const dataInput = {
        login_user_id: userID,
        id: deleteBonus
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setOpen(false);
          await fetchClients(); // Refresh the list after deletion
        } else if (data && data.message === 'Token has expired') {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          await Toastmessage('No response from server', false);
        } else {
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    }

    // Call the function to make the API call
    await fetchData();
  };



  const handleClickOpen = (id) => {
    setOpen(true);
    setBonus(id)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);

    // Search all fields in rows
    const filteredData = rows.filter((row) =>
      Object.values(row).some((field) =>
        String(field).toLowerCase().includes(value)
      )
    );
    setFilteredRows(filteredData); // Update filtered rows
  };

  const clearSearch = () => {
    setSearchText('');
    setFilteredRows(rows); // Reset to original data
  };


  return (

    <Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
          <Typography fontSize={12} color="#333333">
            Assets Type
          </Typography>
        </Box>

        {/* Right Section */}
        {apiResponse?.data?.actions?.add && (
          <Button
            variant="outlined"
            component={Link}
            to="/addasset"
            className='btn-theme-button'
            startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
            style={{ textTransform: 'none' }}
          >
            Add New Assets
          </Button>
        )}
      </Box>



      <Box className="location-container" m={3}>


        <Box className="location-header ">
          <h2>Total Assets Count {rows?.length}</h2>
          <Box sx={{ position: 'relative', width: '300px' }}> {/* Adjust width as needed */}
            <TextField
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              className="search-input"
              fullWidth
              InputProps={{
                endAdornment: searchText && (
                  <span
                    onClick={() => clearSearch()}
                    style={{
                      cursor: 'pointer',
                      color: '#aaa',
                      marginRight: '10px',
                    }}
                  >
                    ✕
                  </span>
                ),
              }}
            />
          </Box>
        </Box>
        <div sx={{ m: 0, p: 0 }}>
          <Box sx={{ width: '100%', display: 'flex' }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={5}
              autoHeight
              pagination
              disableSelectionOnClick
              rowsPerPageOptions={[]}
              className="data-grid"
              sx={{ width: '100%' }} // Ensure DataGrid takes full width
            />

          </Box>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this Asset?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={handleDelete} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

    </Box>
  );
}
